import * as React from 'react';
import { useState, useEffect, useCallback } from 'react';
import { InputWrapper, StyledInput, InputField, InputLabel, InputIcon, InputError, InputHelperText } from './styles.js';
import { EyeIcon } from '../Icons/components/eye.js';
import { EyeOffIcon } from '../Icons/components/eyeOff.js';

const Input = ({ isDisabled =false , type ="text" , error ="" , helperText ="" , value , label , name , placeholder , isPassword , onChange , maskProps , className , ...rest })=>{
    const [val, setVal] = useState(value);
    const [inputType, setInputType] = useState(isPassword ? "password" : type);
    const [showPass, setShowPass] = useState(false);
    useEffect(()=>{
        if (value && value !== val) {
            setVal(value);
        }
    }, [
        val,
        value,
        setVal
    ]);
    const inputChange = useCallback((e)=>{
        if (onChange) {
            onChange(e);
        }
        setVal(e.target.value);
    }, [
        onChange
    ]);
    const handlePass = useCallback(()=>{
        setShowPass(!showPass);
        setInputType(showPass ? "password" : "text");
    }, [
        showPass
    ]);
    const isMaskedInput = Boolean(maskProps && maskProps.mask);
    return /*#__PURE__*/ React.createElement(InputWrapper, {
        className: className
    }, /*#__PURE__*/ React.createElement(StyledInput, {
        className: className && `${className}-container`
    }, /*#__PURE__*/ React.createElement(InputField, {
        className: className && `${className}-input`,
        name: name,
        role: "textbox",
        "aria-invalid": !!error,
        type: inputType,
        disabled: isDisabled,
        placeholder: placeholder,
        value: val,
        onChange: inputChange,
        isMask: isMaskedInput,
        ...maskProps,
        ...rest
    }), !!label && /*#__PURE__*/ React.createElement(InputLabel, {
        htmlFor: name,
        className: className && `${className}-label`,
        active: !!val
    }, label), isPassword && /*#__PURE__*/ React.createElement(InputIcon, {
        className: className && `${className}-passIcon`,
        "aria-label": showPass ? "Hide password" : "Show password",
        onClick: handlePass
    }, showPass ? /*#__PURE__*/ React.createElement(EyeIcon, null) : /*#__PURE__*/ React.createElement(EyeOffIcon, null))), !!error && /*#__PURE__*/ React.createElement(InputError, {
        className: className && `${className}-error`,
        role: "alert"
    }, error), !!helperText && !error && /*#__PURE__*/ React.createElement(InputHelperText, {
        className: className && `${className}-helper-text`
    }, helperText));
};

export { Input };
